import { sessionStorageUtil } from "../utils/storage";

export const getGlossary = async (title, letter, { signal } = {}) => {
  const token = process.env.REACT_APP_API_GUEST_TOKEN;
  const guestEmail = process.env.REACT_APP_API_GUEST_EMAIL;
  const amcCode = sessionStorageUtil.getAmcCode();

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/glossary?email=${encodeURIComponent(guestEmail)}&amc_code=${encodeURIComponent(amcCode)}&status=true${title ? `&title=${encodeURIComponent(title)}` : ""}${letter ? `&letter=${encodeURIComponent(letter)}` : ""}`,
      {
        method: "GET",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        signal
      },
    );

    const data = await response.json();

    // console.log(data.data);

    if (!response.ok || data?.status !== 200) {
      throw new Error(data?.message || "Failed to get Glossary Items");
    }

    return {
      data: data.data,
      error: false,
      message: data?.message || "Get Glossary - Success",
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      error: true,
      message: error?.message || "Failed to get Glossary Items",
    };
  }
};

export const getFAQs = async () => {
  const token = process.env.REACT_APP_API_GUEST_TOKEN;
  const guestEmail = process.env.REACT_APP_API_GUEST_EMAIL;
  const amcCode = sessionStorageUtil.getAmcCode();

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/faq?email=${encodeURIComponent(guestEmail)}&amc_code=${encodeURIComponent(amcCode)}&status=true`, {
      method: "GET",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data?.status !== 200) {
      throw new Error(data?.message || "Failed to get FAQ Items");
      // throw some error, probably or not, idk
    }

    return {
      data: data.data,
      error: false,
      message: data?.message || "Get FAQs - Success",
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      error: true,
      message: error?.message || "Failed to get FAQ Items",
    };
  }
};
